module.exports = __webpack_public_path__ + "static/img/icon_footer_app_download.5e8ecf4.png";


//////////////////
// WEBPACK FOOTER
// ./src/projects/hsbpc/views/welcome/components/img/icon_footer_app_download.png
// module id = Bdiu
// module chunks = 1 5